const footerLinks = [
    {
    name: "linkedin",
    href: "https://www.linkedin.com/in/cierrabeck/",
  },
  {
    name: "medium",
    href: "https://medium.com/@cierrabeck",
  },
  {
    name: "github",
    href: "https://github.com/cierrabeck",
  },
  { name: "email", 
    href: "mailto: cierrabeck422@gmail.com", 
  },
  {
    name: "instagram",
    href: "https://www.instagram.com/cierra_beck/",
  },
];

export default footerLinks;
